export class Task {
    //public AssignedTo
}
